import { isDebug } from '../core/Basics';
const Stats = require('../../vendor/stats.min')

export const Statics = {
  stats:null,

  init: function (__active = true) {
    if(isDebug && __active) {
      this.stats = new Stats();
      this.stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
      document.body.appendChild(this.stats.dom);
    }
  },

  begin: function () {
    if(this.stats) this.stats.begin();
  },

  end: function () {
    if(this.stats) this.stats.end();
  },
};

